import * as types from './types';

const INITIAL_STATE = {
  recipeData: {},
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.COMMON_SET_RECIPE_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.COMMON_SET_RECIPE_DATA:
      return {
        ...state,
        recipeData: payload,
      };
    case types.COMMON_SET_RECIPE_LOADING:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/getrecipe/reducer.js